import useAppQuery from 'hooks/useAppQuery';
import { LeadScreenAndProtectDetailsResponse } from 'models/ScreenAndProtect';
import IntegrationsAPI from 'services/IntegrationsAPI';

const LEAD_DAMAGE_PROTECTION_DETAILS_BASE_QUERY_KEY =
  'lead-damage-protection-details';

const useLeadScreenAndProtectDetails = (leadUid?: string) => {
  const { data, isFetching } = useAppQuery(
    [LEAD_DAMAGE_PROTECTION_DETAILS_BASE_QUERY_KEY, leadUid],
    async () => {
      const response =
        await IntegrationsAPI.get<LeadScreenAndProtectDetailsResponse>(
          `/api/internal/screen-and-protect/leads/${leadUid}`,
        );
      return response.data;
    },
    {
      enabled: !!leadUid,
    },
  );

  const screenAndProtectDetails = data ?? null;

  return {
    screenAndProtectDetails,
    isLoading: isFetching,
  };
};

export default useLeadScreenAndProtectDetails;
